export const ParseFullName = (
	name: string,
	email: string,
): Promise<{ first_name: string; last_name: string } | null> => {
	return new Promise(resolve => {
		let attempts = 0
		let apiUrl = import.meta.env.VITE_APP_NAME_API_FIRST
		let apiKey = import.meta.env.VITE_APP_NAME_API_FIRST_KEY
		let parsedFirstname = '0'
		let parsedLastname = '0'

		const resendRequest = () => {
			if (attempts >= 1) {
				resolve({ first_name: parsedFirstname, last_name: parsedLastname })
				return
			}

			attempts++
			apiUrl = import.meta.env.VITE_APP_NAME_API_SECOND
			apiKey = import.meta.env.VITE_APP_NAME_API_SECOND_KEY
			sendRequest()
		}

		const sendRequest = () => {
			const headers = new Headers()
			headers.append('x-api-key', apiKey)
			headers.append('Content-Type', 'application/json')

			const raw = JSON.stringify({
				name,
				email,
			})

			const requestOptions = {
				method: 'POST',
				headers: headers,
				body: raw,
			}

			fetch(apiUrl, requestOptions)
				.then(response => response.json())
				.then(result => {
					const exceptions = ['5', 5, '0', 0]

					if (result) {
						parsedFirstname = exceptions.includes(result.first_name)
							? parsedFirstname
							: result.first_name
						parsedLastname = exceptions.includes(result.last_name)
							? parsedLastname
							: result.last_name
					}

					if (
						!result ||
						exceptions.includes(result.first_name) ||
						exceptions.includes(result.last_name)
					) {
						resendRequest()

						return
					}

					resolve(result)
				})
				.catch(error => {
					console.log('Name API parse error:', error)
					resendRequest()
				})
		}

		sendRequest()
	})
}
